import {ESCAPE} from "@angular/cdk/keycodes";

export enum Locale {
  EN = 'en', ES = 'es', PT = 'pt', FR = 'fr'
}
